"use client";
// ===================================================
// ControlRoomCard — a single metric tile (label + value + optional hint).
// DS-candidate (Design System ADR §8.5): reusable, not a vTask-local one-off.
// Reuses the Brand v2 Card primitive; tone maps to existing semantic accents.
// ===================================================
import type { ReactNode } from "react";
import { Card } from "@/components/ui/Card";
import { cn } from "@/lib/utils";

type Tone = "default" | "danger" | "warning" | "accent";

const toneCls: Record<Tone, string> = {
  default: "text-white",
  danger: "text-rose-300",
  warning: "text-amber-300",
  accent: "text-teal-200",
};

interface ControlRoomCardProps {
  label: string;
  value: ReactNode;
  hint?: string;
  tone?: Tone;
}

export function ControlRoomCard({ label, value, hint, tone = "default" }: ControlRoomCardProps) {
  return (
    <Card className="rounded-xl p-4 flex flex-col gap-1" dir="rtl">
      <span className="text-[12px] text-slate-400">{label}</span>
      <span className={cn("text-2xl font-bold tabular-nums", toneCls[tone])}>{value}</span>
      {hint && <span className="text-[11px] text-slate-500">{hint}</span>}
    </Card>
  );
}
